import { CSSProperties } from "react";

import { GAP, MENU_WIDTH, MENU_Z_INDEX, VIEWPORT_MARGIN } from "./constants";

// Список категорий открывается СБОКУ от контрола (фильтры живут в модалке с
// overflow-x: hidden, а высокий контрол с множеством выбранных категорий иначе
// утаскивал бы список вниз за край экрана). react-select не умеет боковое
// размещение из коробки, поэтому считаем позицию сами по геометрии контрола:
// controlElement — типизированный проп MenuPortalProps, getBoundingClientRect
// даёт полный DOMRect (в отличие от menuPortal-стиля, где из типов доступны
// только left/width). При скролле фильтров список закрывается (closeMenuOnScroll
// в CategorySelectTree), поэтому отрыв от контрола/наезд на шапку не возникают.
export const computeStyle = (control: HTMLDivElement): CSSProperties => {
  const rect = control.getBoundingClientRect();
  const { innerWidth } = window;
  const spaceRight = innerWidth - rect.right;
  const needed = MENU_WIDTH + GAP;

  // Приоритет — справа; если справа тесно — слева. Верх списка вровень с верхом
  // контрола, дальше — внутренний скролл (max-height задаёт menuList-стиль).
  if (spaceRight >= needed || rect.left >= needed) {
    return {
      position: "fixed",
      top: rect.top,
      left:
        spaceRight >= needed ? rect.right + GAP : rect.left - MENU_WIDTH - GAP,
      width: MENU_WIDTH,
      zIndex: MENU_Z_INDEX,
    };
  }

  // По бокам места нет (узкий вьюпорт) — открываем вниз под контролом.
  const width = Math.min(MENU_WIDTH, innerWidth - 2 * VIEWPORT_MARGIN);
  return {
    position: "fixed",
    top: rect.bottom + GAP / 2,
    left: Math.max(
      VIEWPORT_MARGIN,
      Math.min(rect.left, innerWidth - width - VIEWPORT_MARGIN),
    ),
    width,
    zIndex: MENU_Z_INDEX,
  };
};
